import { svgSprite } from '../../hybrid/wrappers';
import React from 'react';

export const getColorNotification = (subject, firstSymbolSubject) => {
    switch (subject) {
        case 'FinanceDocumentPosted':
            return firstSymbolSubject === '+'
                ? 'rgba(42, 185, 116, 1)'
                : firstSymbolSubject === '-'
                ? 'rgba(220, 53, 153, 1)'
                : 'rgba(67, 95, 197, 1)';
        case 'BonusPayed':
            return 'rgba(42, 185, 116, 1)';
        case 'MarketingRankAssigned':
            return 'rgba(250, 176, 49, 1)';
        case 'UserBecameActive':
            return 'rgba(139, 185, 42, 1)';
        case 'UserRegistered':
            return 'rgba(33, 175, 206, 1)';
        default:
            return 'var(--greenColor)';
    }
};
export const getIcon = (type, css, subject) => {
    const firstSymbolSubject = subject?.[0];
    const backgroundColor = getColorNotification(type, firstSymbolSubject);
    switch (type) {
        case 'FinanceDocumentPosted':
            return (
                <div className={css.notificationsIconWrapper} style={{ backgroundColor }}>
                    {svgSprite(firstSymbolSubject === '+' ? 'menu-plus' : firstSymbolSubject === '-' ? 'menu-minus' : 'money', {
                        width: firstSymbolSubject === '+' || firstSymbolSubject === '-' ? '15px' : '27.5px',
                        height: firstSymbolSubject === '+' || firstSymbolSubject === '-' ? '15px' : '27.5px',
                        fill: 'rgba(255, 255, 255, 1)'
                    })}
                </div>
            );
        case 'BonusPayed':
            return (
                <div className={css.notificationsIconWrapper} style={{ backgroundColor }}>
                    {svgSprite('gift', {
                        width: '30px',
                        height: '30px',
                        fill: 'rgba(255, 255, 255, 1)'
                    })}
                </div>
            );
        case 'MarketingRankAssigned':
            return (
                <div className={css.notificationsIconWrapper} style={{ backgroundColor }}>
                    {svgSprite('star-line', {
                        width: '30px',
                        height: '30px',
                        fill: 'rgba(255, 255, 255, 1)'
                    })}
                </div>
            );
        case 'UserBecameActive':
            return (
                <div className={css.notificationsIconWrapper} style={{ backgroundColor }}>
                    {svgSprite('briefcase', {
                        width: '30px',
                        height: '30px',
                        fill: 'rgba(255, 255, 255, 1)'
                    })}
                </div>
            );
        case 'UserRegistered':
            return (
                <div className={css.notificationsIconWrapper} style={{ backgroundColor }}>
                    {svgSprite('user', {
                        width: '20px',
                        height: '20px',
                        fill: 'rgba(255, 255, 255, 1)'
                    })}
                </div>
            );
        default:
            return (
                <div className={css.notificationsIconWrapper}>
                    {svgSprite('menu-bell', {
                        width: '30px',
                        height: '30px',
                        fill: 'var(--greenColor)'
                    })}
                </div>
            );
    }
};
